export default __webpack_public_path__ + "static/media/subs-image-2.db24934e.webp";